interface PaymentInstrument {
    paymentMethodId: string
    amount?: number
}

interface Basket {
    orderTotal?: number
    shippingTotal?: number
    paymentInstruments?: PaymentInstrument[]
}

const ANNEXCLOUD_PAYMENT_METHODS = new Set([
    'ANNEXCLOUD_STORECREDIT',
    'ANNEXCLOUD_LOYALTY',
    'ANNEXCLOUD_REWARD',
    'GIFT_CERTIFICATE',
    'CARDLESS_PAY',
    'CREDIT_CARD',
    'ASIFLEX'
])

/**
 * Computes the adjusted order total by subtracting Annex Cloud store credit
 * and loyalty reward payment instruments from the basket's order total.
 * Optionally subtracts shipping when free shipping threshold is met.
 */
export const getAdjustedOrderTotal = (
    basket: Basket | undefined,
    hasEarnedFreeShipping = false
): number => {
    if (!basket) return 0

    const credits = (basket.paymentInstruments ?? [])
        .filter((pi) => ANNEXCLOUD_PAYMENT_METHODS.has(pi.paymentMethodId))
        .reduce((sum, pi) => sum + (pi.amount ?? 0), 0)

    const shipping = hasEarnedFreeShipping ? basket.shippingTotal ?? 0 : 0

    return Math.max((basket.orderTotal ?? 0) - credits - shipping, 0)
}
